import configUser from '@/configurations/configUser';
import store from '../store/store';

export default [
  {
    path: '*',
    redirect: '/error',
  },
  {
    path: '/connexion',
    name: 'connexion',
    component: () => import('../views/auth/Connexion'),
  },
  {
    path: '/validation-inscription/:userId',
    name: 'validation-inscription',
    component: () => import('../views/collaborateur/ValidationInscription'),
  },
  {
    path: '/demande-mdp',
    name: 'demande-mdp',
    component: () => import('../views/auth/DemandeDeMotPasse'),
  },
  {
    path: '/mot-de-passe-oublie/:userId',
    name: 'mot-de-passe-oublie',
    component: () => import('../views/collaborateur/ChangerMotDePasse'),
  },
  {
    path: '/',
    name: 'indexHome',
    component: () => import('../views/appPages/index'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('../views/appPages/Home'),
      },
      {
        path: '/recap-budgetaire',
        name: 'recap-budgetaire',
        component: () => import('../views/appPages/RecapBudgetaire'),
      },
      {
        path: '/detail-client/:type/:id',
        name: 'detail-client',
        component: () => import('../views/appPages/DetailClient'),
      },
      {
        path: '/factures',
        name: 'liste-factures',
        component: () => import('../views/appPages/Facture'),
      },
      {
        path: '/mon-compte',
        component: () => import('../views/appPages/monCompte/index'),
        children: [
          {
            path: '',
            name: 'mon.compte.profil',
            component: () => import('../views/appPages/monCompte/Profil'),
          },
          {
            path: 'securite',
            name: 'mon.compte.securite',
            component: () => import('../views/appPages/monCompte/Securite'),
          },
        ],
      },
      {
        path: '/collaborateur',
        name: 'liste-collaborateur',
        component: () => import('../views/appPages/Collaborateur'),
        beforeEnter: (to, from, next) => {
          if (
            [configUser.roles.superAdmin, configUser.roles.admin].includes(
              store.getters['user/role'],
            )
          ) {
            next();
          } else next('/');
        },
      },
    ],
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/appPages/Error'),
  },
];
